export default __webpack_public_path__ + "static/vector-shape4-e47eb5ba4ef43955b5c3f1a0eb3c0778.png";